import filterDate from '@/components/filter/date'

export default function(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        }
      }
    }
  )
}
